import { render } from "./TeachingPlanEditor.vue?vue&type=template&id=965a21f4&scoped=true&ts=true"
import script from "./TeachingPlanEditor.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanEditor.vue?vue&type=script&lang=ts"

import "./TeachingPlanEditor.vue?vue&type=style&index=0&id=965a21f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965a21f4"]])

export default __exports__